import { useRef, useEffect } from 'react';

export default function HtmlPreview({ html, direction = 'ltr', language = 'fr' }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!iframeRef.current || !html) return;

    const doc = iframeRef.current.contentDocument;
    doc.open();
    doc.write(`<!DOCTYPE html>
<html lang="${language}" dir="${direction}">
<head>
<meta charset="UTF-8">
<style>
  body { font-family: system-ui, sans-serif; padding: 24px; line-height: 1.7; color: #1e293b; max-width: 800px; text-align: ${direction === 'rtl' ? 'right' : 'left'}; }
  h1, h2, h3, h4 { margin-top: 1.2em; }
  h1 { font-size: 26px; border-bottom: 1px solid #e2e8f0; padding-bottom: 8px; }
  h2 { font-size: 21px; }
  h3 { font-size: 17px; }
  table { border-collapse: collapse; width: 100%; margin: 16px 0; }
  th, td { border: 1px solid #cbd5e1; padding: 8px 12px; text-align: ${direction === 'rtl' ? 'right' : 'left'}; }
  th { background: #f1f5f9; font-weight: 600; }
  hr { border: none; border-top: 1px solid #e2e8f0; margin: 24px 0; }
  ul, ol { padding-left: 24px; }
  blockquote { border-left: 3px solid #3b82f6; padding-left: 16px; color: #64748b; }
  strong { font-weight: 700; }
</style>
</head>
<body>${html}</body>
</html>`);
    doc.close();
  }, [html, direction, language]);

  if (!html) {
    return <p style={{ color: 'var(--text-dim)' }}>Aucun contenu HTML.</p>;
  }

  return (
    <iframe
      ref={iframeRef}
      className="html-preview-frame"
      title="HTML Preview"
      sandbox="allow-same-origin"
    />
  );
}
